/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */


const sl = {
    name: "Slovenščina",
    english_name: "Slovenian",
    code: "sl",
    dictionary: {
        about: "O programu",
        account: "Račun",
        account_password: "Potrdite geslo računa",
        access_granted_to: "Dostop odobren za",
        add_existing_account: "Dodaj obstoječi račun",
        all_fields_required: 'Vsa polja so obvezna.',
        allow: 'Dovoli',
        apply: "Uporabi",
        ascending: 'Naraščajoče',
        associated_websites: "Povezana spletna mesta",
        auto_arrange: 'Samodejno razporedi',
        background: "Ozadje",
        browse: "Brskaj",
        cancel: 'Prekliči',
        center: 'Na sredino',
        change: 'Spremeni',
        change_always_open_with: "Ali želite to vrsto datotek vedno odpirati s/z",
        change_desktop_background: 'Spremeni ozadje namizja …',
        change_email: "Spremeni e-poštni naslov",
        change_language: "Spremeni jezik",
        change_password: "Spremeni geslo",
        change_ui_colors: "Spremeni barve vmesnika",
        change_username: "Spremeni uporabniško ime",
        clock_visibility: 'Vidnost ure',
        close: 'Zapri',
        close_all_windows: "Zapri vsa okna",
        close_all_windows_confirm: "Ali ste prepričani, da želite zapreti vsa okna?",
        close_all_windows_and_log_out: 'Zapri okna in se odjavi',
        color: 'Barva',
        confirm: 'Potrdi',
        confirm_2fa_setup: 'Kodo sem dodal v svojo aplikacijo za preverjanje pristnosti',
        confirm_2fa_recovery: 'Svoje obnovitvene kode sem shranil na varno lokacijo',
        confirm_account_for_free_referral_storage_c2a: 'Ustvarite račun in potrdite svoj e-poštni naslov, da prejmete 1 GB brezplačnega prostora za shranjevanje. Tudi vaš prijatelj bo dobil 1 GB brezplačnega prostora za shranjevanje.',
        confirm_code_generic_incorrect: "Napačna koda.",
        confirm_code_generic_too_many_requests: "Preveč zahtev. Počakajte nekaj minut.",
        confirm_code_generic_submit: "Pošlji kodo",
        confirm_code_generic_try_again: "Poskusi znova",
        confirm_code_generic_title: "Vnesite potrditveno kodo",
        confirm_code_2fa_instruction: "Vnesite 6-mestno kodo iz vaše aplikacije za preverjanje pristnosti.",
        confirm_code_2fa_submit_btn: "Pošlji",
        confirm_code_2fa_title: "Vnesite 2FA kodo",
        confirm_delete_multiple_items: 'Ali ste prepričani, da želite trajno izbrisati te elemente?',
        confirm_delete_single_item: 'Ali želite trajno izbrisati ta element?',
        confirm_open_apps_log_out: 'Imate odprte aplikacije. Ste prepričani, da se želite odjaviti?',
        confirm_new_password: "Potrdite novo geslo",
        confirm_delete_user: "Ali ste prepričani, da želite izbrisati svoj račun? Vse vaše datoteke in podatki bodo trajno izbrisani. Tega dejanja ni mogoče razveljaviti.",
        confirm_delete_user_title: "Izbris računa?",
        confirm_session_revoke: "Ali ste prepričani, da želite preklicati to sejo?",
        confirm_your_email_address: "Potrdite svoj e-poštni naslov",
        contact_us: "Kontaktirajte nas",
        contact_us_verification_required: "Za uporabo tega morate imeti potrjen e-poštni naslov.",
        contain: 'Ohrani',
        continue: "Nadaljuj",
        copy: 'Kopiraj',
        copy_link: "Kopiraj povezavo",
        copying: "Kopiranje",
        copying_file: "Kopiranje %%",
        cover: 'Ovitek',
        create_account: "Ustvari račun",
        create_free_account: "Ustvari brezplačen račun",
        create_desktop_shortcut: "Ustvari bližnjico (namizje)",
        create_desktop_shortcut_s: "Ustvari bližnjice (namizje)",
        create_shortcut: "Ustvari bližnjico",
        create_shortcut_s: "Ustvari bližnjice",
        credits: "Zasluge",
        current_password: "Trenutno geslo",
        cut: 'Izreži',
        clock: "Ura",
        clock_visible_hide: 'Skrij - Vedno skrito',
        clock_visible_show: 'Prikaži - Vedno vidno',
        clock_visible_auto: 'Samodejno – privzeto, vidno samo v celozaslonskem načinu.',
        close_all: 'Zapri vse',
        created: 'Ustvarjeno',
        date_modified: 'Datum spremembe',
        default: 'Privzeto',
        delete: 'Izbriši',
        delete_account: "Izbriši račun",
        delete_permanently: "Trajno izbriši",
        deleting_file: "Brisanje %%",
        deploy_as_app: 'Izvedi kot aplikacijo',
        descending: 'Padajoče',
        desktop: 'Namizje',
        desktop_background_fit: "Prilagodi",
        developers: "Razvijalci",
        dir_published_as_website: `%strong% je bilo objavljeno na:`,
        disable_2fa: 'Onemogoči 2FA',
        disable_2fa_confirm: "Ali ste prepričani, da želite onemogočiti 2FA?",
        disable_2fa_instructions: "Za onemogočanje 2FA vnesite svoje geslo.",
        disassociate_dir: "Prekini povezavo z imenikom",
        documents: 'Dokumenti',
        dont_allow: 'Ne dovoli',
        download: 'Prenos',
        download_file: 'Prenesi datoteko',
        downloading: "Prenašanje",
        email: "E-pošta",
        email_change_confirmation_sent: "Potrditveno e-poštno sporočilo je bilo poslano na vaš novi e-poštni naslov. Preverite svoj poštni predal in sledite navodilom za dokončanje postopka.",
        email_invalid: 'E-pošta ni veljavna.',
        email_or_username: "E-pošta ali uporabniško ime",
        email_required: 'E-pošta je obvezna.',
        empty_trash: 'Izprazni smeti',
        empty_trash_confirmation: `Ali ste prepričani, da želite trajno izbrisati elemente iz smeti?`,
        emptying_trash: 'Praznjenje smeti …',
        enable_2fa: 'Omogoči 2FA',
        end_hard: "Prisilno končaj",
        end_process_force_confirm: "Ali ste prepričani, da želite prisilno končati ta proces?",
        end_soft: "Končaj",
        enlarged_qr_code: "Povečana QR-koda",
        enter_password_to_confirm_delete_user: "Za potrditev izbrisa računa vnesite svoje geslo",
        error_message_is_missing: "Manjka sporočilo o napaki.",
        error_unknown_cause: "Prišlo je do neznane napake.",
        error_uploading_files: "Nalaganje datotek ni uspelo",
        favorites: "Priljubljene",
        feedback: "Povratne informacije",
        feedback_c2a: "S spodnjim obrazcem nam pošljite povratne informacije, komentarje in poročila o napakah.",
        feedback_sent_confirmation: "Hvala, ker ste nas kontaktirali. Če imate z računom povezan e-poštni naslov, vam bomo odgovorili v najkrajšem možnem času.",
        fit: "Prilagodi",
        folder: 'Mapa',
        force_quit: 'Prisilni izhod',
        forgot_pass_c2a: "Ste pozabili geslo?",
        from: "Od",
        general: "Splošno",
        get_a_copy_of_on_puter: `Pridobite kopijo '%%' na Puter.com!`,
        get_copy_link: 'Pridobi povezave kopije',
        hide_all_windows: "Skrij vsa okna",
        home: 'Domov',
        html_document: 'HTML dokument',
        hue: 'Odtenek',
        image: 'Slika',
        incorrect_password: "Napačno geslo",
        invite_link: "Povezava za povabilo",
        item: 'element',
        items_in_trash_cannot_be_renamed: `Tega elementa ni mogoče preimenovati, ker je v smeteh. Če želite preimenovati ta element, ga najprej povlecite iz smeti.`,
        jpeg_image: 'JPEG slika',
        keep_in_taskbar: 'Ohrani v opravilni vrstici',
        language: "Jezik",
        license: "Licenca",
        lightness: 'Svetloba',
        link_copied: "Povezava kopirana",
        loading: 'Nalaganje',
        log_in: "Prijava",
        log_into_another_account_anyway: 'Vseeno se prijavite v drug račun',
        log_out: 'Odjava',
        looks_good: "Videti je v redu!",
        manage_sessions: "Upravljanje sej",
        modified: 'Spremenjeno',
        move: 'Premakni',
        moving_file: "Premikanje %%",
        my_websites: "Moja spletna mesta",
        minimize: "Pomanjšaj",
        reload_app: "Znova naloži aplikacijo",
        name: 'Ime',
        name_cannot_be_empty: 'Ime ne sme biti prazno.',
        name_cannot_contain_double_period: "Ime ne sme biti znak '..'.",
        name_cannot_contain_period: "Ime ne sme biti znak '.'.",
        name_cannot_contain_slash: "Ime ne sme vsebovati znaka '/'.",
        name_must_be_string: "Ime je lahko le niz.",
        name_too_long: `Ime ne sme biti daljše od %% znakov.`,
        new: 'Novo',
        new_email: 'Novo e-poštno sporočilo',
        new_folder: 'Nova mapa',
        new_password: "Novo geslo",
        new_username: "Novo uporabniško ime",
        no: 'Ne',
        no_dir_associated_with_site: 'S tem naslovom ni povezana nobena mapa.',
        no_websites_published: " Niste še objavili nobenega spletnega mesta. Za začetek z desnim klikom kliknite mapo.",
        ok: 'V redu',
        open: "Odpri",
        new_window: "Novo okno",
        open_in_new_tab: "Odpri v novem zavihku",
        open_in_new_window: "Odpri v novem oknu",
        open_trash: "Odpri smeti",
        open_with: "Odpri z",
        original_name: 'Izvirno ime',
        original_path: 'Izvirna pot',
        oss_code_and_content: "Odprtokodna programska oprema in vsebina",
        password: "Geslo",
        password_changed: "Geslo je bilo spremenjeno.",
        password_recovery_rate_limit: "Dosegli ste omejitev zahtev; počakajte nekaj minut. Da to v prihodnje preprečite, ne osvežujte strani prevečkrat.",
        password_recovery_token_invalid: "Ta žeton za obnovitev gesla ni več veljaven.",
        password_recovery_unknown_error: "Prišlo je do neznane napake. Poskusite znova pozneje.",
        password_required: 'Geslo je zahtevano.',
        password_strength_error: "Geslo mora biti dolgo vsaj 8 znakov in vsebovati vsaj eno veliko črko, eno malo črko, eno številko in en poseben znak.",
        passwords_do_not_match: '`Novo geslo` in `Potrdi novo geslo` se ne ujemata.',
        paste: 'Prilepi',
        paste_into_folder: "Prilepi v mapo",
        path: 'Pot',
        personalization: "Prilagajanje",
        pick_name_for_website: "Izberite ime za svoje spletno mesto:",
        pick_name_for_worker: "Izberite ime za svojega workerja:",
        picture: "Slika",
        pictures: 'Slike',
        plural_suffix: '', // "i", "je" - masculine; "e", "i" - feminine; "a", "i" - neuter
        powered_by_puter_js: `Poganja {{link=docs}}Puter.js{{/link}}`,
        preparing: "Priprava...",
        preparing_for_upload: "Priprava na prenos...",
        print: 'Natisni',
        privacy: "Zasebnost",
        proceed_to_login: 'Nadaljuj na prijavo',
        proceed_with_account_deletion: "Nadaljuj z izbrisom računa",
        process_status_initializing: "Inicializacija",
        process_status_running: "V izvajanju",
        process_type_app: 'Aplikacija',
        process_type_init: 'Init',
        process_type_ui: 'UI',
        properties: "Lastnosti",
        public: 'Javno',
        publish: "Objavi",
        publish_as_website: 'Objavi kot spletno stran',
        publish_as_serverless_worker: 'Objavi kot Worker',
        puter_description: `Puter je osebni oblak, ki na prvo mesto postavlja zasebnost in varno hrani vse vaše datoteke, aplikacije in igre, do katerih lahko dostopate od koder koli in kadar koli.`,
        reading: "Branje %strong%",
        writing: "Pisanje %strong%",
        recent: "Nedavno",
        recommended: "Priporočeno",
        recover_password: "Obnovi geslo",
        refer_friends_c2a: "Pridobite 1 GB za vsakega prijatelja, ki na Puterju ustvari in potrdi račun. Tudi vaš prijatelj dobi 1 GB!",
        refer_friends_social_media_c2a: `Pridobite 1 GB brezplačnega prostora za shranjevanje na Puter.com!`,
        refresh: 'Osveži',
        release_address_confirmation: `Ali ste prepričani, da želite objaviti ta naslov?`,
        remove_from_taskbar:'Odstrani iz opravilne vrstice',
        rename: 'Preimenuj',
        repeat: 'Ponovi',
        replace: 'Zamenjaj',
        replace_all: 'Zamenjaj vse',
        resend_confirmation_code: "Znova pošlji potrditveno kodo",
        reset_colors: "Ponastavi barve",
        restart_puter_confirm: "Ali ste prepričani, da želite znova zagnati Puter?",
        restore: "Obnovi",
        save: 'Shrani',
        saturation: 'Nasičenost',
        save_account: 'Shrani račun',
        save_account_to_get_copy_link: "Za nadaljevanje ustvarite račun.",
        save_account_to_publish: 'Za nadaljevanje ustvarite račun.',
        save_session: 'Shrani sejo',
        save_session_c2a: 'Ustvarite račun, da shranite trenutno sejo in se izognete izgubi dela.',
        scan_qr_c2a: 'Skenirajte spodnjo kodo,\nda se prijavite v to sejo iz drugih naprav',
        scan_qr_2fa: 'Skenirajte QR kodo z aplikacijo za preverjanje pristnosti',
        scan_qr_generic: 'Skenirajte to QR kodo s telefonom ali drugo napravo',
        search: 'Iskanje',
        seconds: 'sekund',
        security: "Varnost",
        select: "Izberi",
        selected: 'izbrano',
        select_color: 'Izberite barvo …',
        sessions: "Seje",
        send: "Pošlji",
        send_password_recovery_email: "Pošlji e-pošto za obnovitev gesla",
        session_saved: "Hvala za ustvarjen račun. Ta seja je bila shranjena.",
        settings: "Nastavitve",
        set_new_password: "Nastavi novo geslo",
        share: "Deli",
        share_to: "Deli na",
        share_with: "Deli z:",
        shortcut_to: "Bližnjica do",
        show_all_windows: "Pokaži vsa okna",
        show_hidden: 'Prikaži skrito',
        sign_in_with_puter: "Prijavite se s Puterjem",
        sign_up: "Ustvari račun",
        signing_in: "Prijavljanje…",
        size: 'Velikost',
        skip: 'Preskoči',
        something_went_wrong: "Nekaj je šlo narobe.",
        sort_by: 'Razvrsti po',
        start: 'Začetek',
        status: "Stanje",
        storage_usage: "Poraba prostora",
        storage_puter_used: 'uporabljeno s strani Puterja',
        taking_longer_than_usual: 'Traja malo dlje kot običajno. Prosimo, počakajte ...',
        task_manager: "Upravitelj opravil",
        taskmgr_header_name: "Ime",
        taskmgr_header_status: "Stanje",
        taskmgr_header_type: "Vrsta",
        terms: "Pogoji",
        text_document: 'Besedilni dokument',
        'toolbar.enter_fullscreen': 'Preklopi celozaslonski način',
        'toolbar.github': 'GitHub',
        'toolbar.refer': 'Priporoči',
        'toolbar.save_account': 'Shrani račun',
        'toolbar.search': 'Iskanje',
        'toolbar.qrcode': 'QR koda',
        tos_fineprint: `S klikom na 'Ustvari brezplačen račun' se strinjate s Puterjevimi {{link=terms}}pogoji storitve{{/link}} in {{link=privacy}}pravilnikom o zasebnosti{{/link}}.`,
        transparency: "Prosojnost",
        trash: 'Smeti',
        two_factor: 'Dvofaktorska avtentikacija',
        two_factor_disabled: '2FA onemogočeno',
        two_factor_enabled: '2FA omogočeno',
        type: 'Vrsta',
        type_confirm_to_delete_account: "Za izbris računa vpišite 'Potrdi'.",
        ui_colors: "Barve uporabniškega vmesnika",
        ui_manage_sessions: "Upravitelj sej",
        ui_revoke: "Prekliči",
        undo: 'Razveljavi',
        unlimited: 'Neomejeno',
        unzip: "Razpakiraj",
        unzipping: "Razpakiranje %strong%",
        upload: 'Naloži',
        upload_here: 'Naloži tukaj',
        used_of: '{{used}} uporabljeno od {{available}}',
        usage: 'Uporaba',
        username: "Uporabniško ime",
        username_changed: 'Uporabniško ime je bilo uspešno posodobljeno.',
        username_required: 'Uporabniško ime je zahtevano.',
        versions: "Različice",
        videos: 'Videoposnetki',
        visibility: 'Vidnost',
        yes: 'Da',
        yes_release_it: 'Da, izpusti',
        you_have_been_referred_to_puter_by_a_friend: "Prijatelj vas je povabil na Puter!",
        zip: "Stisni",
        sequencing: "Razvrščanje %strong%",
        worker: "Worker",
        zipping: "Stiskanje %strong%",

        // === 2FA Setup ===
        setup2fa_1_step_heading: 'Odprite aplikacijo za preverjanje pristnosti',
        setup2fa_1_instructions: `
            Uporabite lahko katero koli aplikacijo za preverjanje pristnosti, ki podpira protokol enkratnega gesla na podlagi časa (TOTP).
Na voljo jih je veliko, če pa niste prepričani, je <a target="_blank" href="https://authy.com/download">Authy</a>
odlična izbira za Android in iOS.
        `,
        setup2fa_2_step_heading: 'Skenirajte QR kodo',
        setup2fa_3_step_heading: 'Vnesite 6-mestno kodo',
        setup2fa_4_step_heading: 'Kopirajte svoje obnovitvene kode',
        setup2fa_4_instructions: `
            Te kode za obnovitev so edini način za dostop do računa, če izgubite telefon ali ne morete uporabljati aplikacije za preverjanje pristnosti.
Shranite jih na varno mesto.
        `,
        setup2fa_5_step_heading: 'Potrdite nastavitev 2FA',
        setup2fa_5_confirmation_1: 'Moje obnovitvene kode so shranjene na varno mesto',
        setup2fa_5_confirmation_2: 'Pripravljen/a sem omogočiti 2FA',
        setup2fa_5_button: 'Omogoči 2FA',

        // === 2FA Login ===
        login2fa_otp_title: 'Vnesite kodo 2FA',
        login2fa_otp_instructions: 'Vnesite 6-mestno kodo iz aplikacije za preverjanje pristnosti.',
        login2fa_recovery_title: 'Vnesite kodo za obnovitev',
        login2fa_recovery_instructions: 'Za dostop do računa vnesite eno od svojih obnovitvenih kod.',
        login2fa_use_recovery_code: 'Uporabi obnovitveno kodo',
        login2fa_recovery_back: 'Nazaj',
        login2fa_recovery_placeholder: 'XXXXXXXX',

        // Sharing
        'Editor': 'Urejevalnik',
        'Viewer': 'Pregledovalnik',
        'People with access': 'Ljudje z dostopom',
        'Share With…' : 'Deli z…',
        'Owner': 'Lastnik',
        "You can't share with yourself.": `Ne morete deliti sami s seboj`,
        'This user already has access to this item': 'Ta uporabnik že ima dostop do tega elementa',

        // Billing
        'billing.change_payment_method': "Spremeni",
        'billing.cancel': "Prekliči",
        'billing.download_invoice': "Prenesi",
        'billing.payment_method': "Način plačila",
        'billing.payment_method_updated': "Način plačila posodobljen!",
        'billing.confirm_payment_method': 'Potrdi način plačila',
        'billing.payment_history': "Zgodovina plačil",
        'billing.refunded': "Povrnjeno",
        'billing.paid': "Plačano",
        'billing.ok': "V redu",
        'billing.resume_subscription': 'Nadaljujte z naročnino',
        'billing.subscription_cancelled': 'Vaša naročnina je bila preklicana.',
        'billing.subscription_cancelled_description': 'Dostop do naročnine boste imeli še vedno do konca tega obračunskega obdobja.',
        'billing.offering.free': 'Brezplačno',
        'billing.offering.basic': 'Osnovno',
        'billing.offering.pro': 'Profesionalno',
        'billing.offering.professional': 'Profesionalno',
        'billing.offering.business': 'Poslovno',
        'billing.cloud_storage': 'Shramba v oblaku',
        'billing.ai_access': 'Dostop z umetno inteligenco',
        'billing.bandwidth': 'Pasovna širina',
        'billing.apps_and_games': 'Aplikacije & Igre',
        'billing.upgrade_to_pro': 'Nadgradite na %strong%',
        'billing.switch_to': 'Preklopite na %strong%',
        'billing.payment_setup': 'Nastavitev plačila',
        'billing.back': 'Nazaj',
        'billing.you_are_now_subscribed_to': 'Zdaj ste naročeni na raven %strong%.',
        'billing.you_are_now_subscribed_to_without_tier': 'Zdaj ste naročeni',
        'billing.subscription_cancellation_confirmation': 'Ali ste prepričani, da želite preklicati naročnino?',
        'billing.subscription_setup': 'Nastavitev naročnine',
        'billing.cancel_it': 'Prekliči',
        'billing.keep_it': 'Obdrži',
        'billing.subscription_resumed': 'Vaša naročnina na %strong% je bila obnovljena!',
        'billing.upgrade_now': 'Nadgradite zdaj',
        'billing.upgrade': 'Nadgradite',
        'billing.currently_on_free_plan': 'Trenutno imate brezplačen paket.',
        'billing.download_receipt': 'Prenesi potrdilo',
        'billing.subscription_check_error': 'Pri preverjanju stanja vaše naročnine je prišlo do težave.',
        'billing.payment_method_updated': 'Način plačila posodobljen!',
        'billing.email_confirmation_needed': 'Vaš e-poštni naslov ni bil potrjen. Zdaj vam bomo poslali kodo za potrditev.',
        'billing.sub_cancelled_but_valid_until': 'Preklicali ste naročnino in ta se bo ob koncu obračunskega obdobja samodejno preklopila na brezplačno raven. Naročnine vam ne bomo zaračunali, razen če se ponovno naročite.',
        'billing.current_plan_until_end_of_period': 'Vaš trenutni paket do konca tega obračunskega obdobja.',
        'billing.current_plan': 'Trenutni paket',
        'billing.cancelled_subscription_tier': 'Preklicana naročnina (%%)',
        'billing.manage': 'Upravljajte',
        'billing.limited': 'Omejeno',
        'billing.expanded': 'Razširjeno',
        'billing.accelerated': 'Pospešeno',
        'billing.enjoy_msg': 'Izkoristite %% shrambe v oblaku in druge ugodnosti.',
        'too_many_attempts': 'Preveč poskusov. Poskusite znova pozneje.',
        'server_timeout': 'Strežnik je potreboval predolgo za odgovor. Poskusite znova.',
        'signup_error': 'Med prijavo je prišlo do napake. Poskusite znova.',
        
        // Welcome Window
        'welcome_title': 'Dobrodošli na vašem Osebnem Internetnem Računalniku',
        'welcome_description': 'Shranjujte datoteke, igrajte igre, poiščite odlične aplikacije in še veliko več! Vse na enem mestu, dostopno od kjer koli in kadar koli.',
        'welcome_get_started': 'Začnite',
        'welcome_terms': 'Pogoji',
        'welcome_privacy': 'Zasebnost',
        'welcome_developers': 'Razvijalci',
        'welcome_open_source': 'Odprtokodno',
        'welcome_instant_login_title': 'Takojšnja prijava!',
        
        // Alert Window
        'alert_error_title': 'Napaka!',
        'alert_warning_title': 'Opozorilo!',
        'alert_info_title': 'Info',
        'alert_success_title': 'Uspeh!',
        'alert_confirm_title': 'Ali ste prepričani?',
        'alert_yes': 'Da',
        'alert_no': 'Ne',
        'alert_retry': 'Poskusi znova',
        'alert_cancel': 'Preklic',
        
        // Signup Window
        'signup_confirm_password': 'Potrdite geslo',
        
        // Login Window
        'login_email_username_required': 'Zahtevan je e-poštni naslov ali uporabniško ime',
        'login_password_required': 'Zahtevano je geslo',
        
        // Various Window Titles
        'window_title_open': 'Odpri',
        'window_title_change_password': 'Spremeni geslo',
        'window_title_select_font': 'Izberi pisavo…',
        'window_title_session_list': 'Seznam sej!',
        'window_title_set_new_password': 'Nastavite novo geslo',
        'window_title_instant_login': 'Takojšnja prijava!',
        'window_title_publish_website': 'Objavite spletno stran',
        'window_title_publish_worker': 'Objavite Workerja',
        'window_title_authenticating': 'Preverjanje pristnosti ...',
        'window_title_refer_friend': 'Priporoči prijatelju!',
        
        // Desktop UI
        'desktop_show_desktop': 'Prikaži namizje',
        'desktop_show_open_windows': 'Prikaži odprta okna',
        'desktop_exit_full_screen': 'Izhod iz celozaslonskega načina',
        'desktop_enter_full_screen': 'Preklopi na celozaslonski način',
        'desktop_position': 'Položaj',
        'desktop_position_left': 'Levo',
        'desktop_position_bottom': 'Spodaj',
        'desktop_position_right': 'Desno',
        // Item UI
        'item_shared_with_you': 'Uporabnik je ta element delil z vami.',
        'item_shared_by_you': 'Ta element ste delili z vsaj enim drugim uporabnikom.',
        'item_shortcut': 'Bližnjica',
        'item_associated_websites': 'Povezano spletno mesto',
        'item_associated_websites_plural': 'Povezana spletna mesta',
        'no_suitable_apps_found': 'Ni najdenih ustreznih aplikacij',
        
        // Window UI
        'window_click_to_go_back': 'Kliknite za nazaj',
        'window_click_to_go_forward': 'Kliknite za naprej',
        'window_click_to_go_up': 'Kliknite za prehod za en imenik navzgor.',
        'window_title_public': 'Javno',
        'window_title_videos': 'Videoposnetki',
        'window_title_pictures': 'Slike',
        'window_title_puter': 'Puter',
        'window_folder_empty': 'Ta mapa je prazna',
        
        // Website Management
        'manage_your_subdomains': 'Upravljajte svoje poddomene',

        'open_containing_folder': 'Odpri vsebujočo mapo',
    }
};

export default sl;
